if (globalThis.jQuery?.fn) {
    globalThis.jQuery.fn.selectedText = function() {
        return this.find('option:selected').text();
    };
}
const JQWrapper = (...args)=>{
    if (!globalThis.jQuery) {
        if (process.env.NODE_ENV !== 'test') {
            // eslint-disable-next-line no-console
            console.warn('jQuery not found. Make sure jQuery is installed and exposed on globalThis.$ and globalThis.jQuery.');
        }
        return undefined;
    }
    return globalThis.jQuery(...args);
};
const errand = {
    get action () {
        return JQWrapper('#action');
    },
    get receiver () {
        return JQWrapper('#receiver');
    },
    get comment () {
        return JQWrapper('#comment');
    }
};
export default {
    errand: errand
};
